export enum FormFieldType {
    Text = 1,
    TextArea = 2,
    Number = 3,
    Toggle = 4,
    Checkbox = 5,
    Date = 6,
    SingleSelection = 7,
    MultipleSelection = 8,
    Time = 9,
    Array = 10,
    Button = 11,
    Label = 12,
    DateTime = 13,
    Radio = 14,
    FileAttachments = 15,
    HierarchicalSelection = 16
}

export enum FieldRenderType {
  SELECT = 'select',
  TEXT = 'text',
  NUMBER = 'number',
  TEXTAREA = 'textarea',
  DATE_TIME = 'datetime',
  TIME = 'time'
}

export type FieldRenderTypeValue = `${FieldRenderType}`;

export const FIELD_RENDER_TYPE_LABELS: Record<FieldRenderType, string> = {
  [FieldRenderType.SELECT]: 'Dropdown',
  [FieldRenderType.NUMBER]: 'Number',
  [FieldRenderType.TEXTAREA]: 'Text area',
  [FieldRenderType.TEXT]: 'Text',
  [FieldRenderType.DATE_TIME]: 'Date and time',
  [FieldRenderType.TIME]: 'Time'
};
